import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Protects the admin shell — authentication is REQUIRED.
 * Unauthenticated users are sent to /login, so the app never fires tokenless data calls
 * (which 401). "Authenticated" means an AM token is present, from either a real Admin Login
 * or `environment.devAuthToken` (paste a valid AM token there to test before a real admin
 * user exists — see ATTENTION.md / COORDINATION §4 for the bootstrap step).
 */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.isAuthenticated() ? true : router.createUrlTree(['/login']);
};
